import mapsApi from '@/api/maps';

let loc = JSON.parse(localStorage.getItem('loc'));
if (loc === null) {
	loc = {
		'lat': '',
		'lng': '',
	}
}

const defaultState = () => ({
	location: loc,
	gettingLocation: false
});

const state = defaultState();

const mutations = {
	setGettingLocation(state, data) {
		state.gettingLocation = data
	},
	setLocation(state, data) {
		state.location = data
		localStorage.setItem('loc', JSON.stringify(state.location));
	}
};

const actions = {
	getGeolocation({ commit }) {
		if(!("geolocation" in navigator)) {
			mapsApi.getLocation().then(({ data: { data } }) => {
				commit('setGettingLocation', false)
				commit('setLocation', {
					'lat': data.latitude,
					'lng': data.longitude
				});
			});
		}
		commit('setGettingLocation', true)
		navigator.geolocation.getCurrentPosition(loc => {
			commit('setGettingLocation', false)
			var position = {
				lat: loc.coords.latitude,
				lng: loc.coords.longitude
			}
			commit('setLocation', position)
		}, () => {
			mapsApi.getLocation().then(({ data: { data } }) => {
				commit('setGettingLocation', false)
				commit('setLocation', {
					'lat': data.latitude,
					'lng': data.longitude
				});
			});
		})
	},
	postGeolocation({ commit }, params) {
		commit('setLocation', {
			'lat': params.lat,
			'lng': params.lng
		});
	},
	getMaps({ commit }, params) {
		mapsApi.getMaps(params).then(function(response) {
			commit('setLocation', {
				'lat': response.lat,
				'lng': response.lng
			});
		});
		
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};